module.exports = __webpack_public_path__ + "static/media/logo.d96f2148.svg";